import { PinInput as ChakraPinInput } from "@chakra-ui/react";
import { forwardRef } from "react";
import type { ComponentProps } from "react";
import type { PinInputFieldSharedProps } from "./PinInputField.props";

type ChakraInputProps = ComponentProps<typeof ChakraPinInput.Input>;

export type PinInputFieldProps = PinInputFieldSharedProps &
  Omit<ChakraInputProps, "index"> & {
    // Backward compatible: parent can inject this
    index?: number;
  };

const PinInputField = forwardRef<HTMLInputElement, PinInputFieldProps>(
  function PinInputField(props: PinInputFieldProps, ref) {
    const { variant, index, ...rest } = props;

    // Responsive sizing: smaller on mobile to fit 6 inputs
    const responsiveSize = { base: "element.4xl", xs: "element.5xl" };
    const responsiveFontSize = { base: "2xl", xs: "4xl" };

    if (variant === "success") {
      return (
        <ChakraPinInput.Input
          data-testid="pin-input-field"
          ref={ref}
          index={index ?? 0}
          h={responsiveSize}
          w={responsiveSize}
          minW="none"
          fontSize={responsiveFontSize}
          fontWeight={700}
          color="primary.900"
          backgroundColor="primary.200"
          border="2px solid"
          borderColor="primary.500"
          borderRadius="md"
          _focus={{ borderColor: "primary.900" }}
          _hover={{ borderColor: "primary.500" }}
          {...rest}
        />
      );
    }
    if (variant === "error") {
      return (
        <ChakraPinInput.Input
          data-testid="pin-input-field"
          ref={ref}
          index={index ?? 0}
          h={responsiveSize}
          w={responsiveSize}
          minW="none"
          fontSize={responsiveFontSize}
          fontWeight={700}
          color="red.900"
          backgroundColor="red.200"
          border="2px solid"
          borderColor="red.500"
          borderRadius="md"
          _focus={{ borderColor: "red.900" }}
          _hover={{ borderColor: "red.500" }}
          {...rest}
        />
      );
    }
    return (
      <ChakraPinInput.Input
        data-testid="pin-input-field"
        ref={ref}
        index={index ?? 0}
        h={responsiveSize}
        w={responsiveSize}
        minW="none"
        border="1px solid"
        borderColor="gray.400"
        borderRadius="md"
        fontSize={responsiveFontSize}
        fontWeight={700}
        _focus={{ borderColor: "primary.900" }}
        _hover={{ borderColor: "primary.500" }}
        {...rest}
      />
    );
  }
);

export default PinInputField;
